import { BASE } from './index';
import axios from './http';
const fund = {
    // 回访记录
    tdcOwnerrechargeflow: params => axios.post(`${BASE.PRO1}/tdcOwner/recharge/flow`,  params ),


};

export default fund;
